module.exports = __webpack_public_path__ + "static/media/icon-medium-social.e71698e7.svg";